"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAll = exports.transformObject = void 0;
const yup = __importStar(require("yup"));
const DEFINITION_PREFIX = 'yup.';
const isYupCallDefinition = (value) => (Array.isArray(value)
    && typeof value[0] === 'string'
    && value[0].startsWith(DEFINITION_PREFIX));
const isYupSchemaDefinition = (value) => (Array.isArray(value) && isYupCallDefinition(value[0]));
const transformSchema = (json, instance) => {
    const mapArgument = (argument) => {
        if (isYupSchemaDefinition(argument)) {
            return transformSchema(argument, instance);
        }
        if (Array.isArray(argument)) {
            return argument.map(mapArgument);
        }
        if (Object.prototype.toString.call(argument) === '[object Object]') {
            return transformObject(argument, instance);
        }
        return argument;
    };
    return json.reduce((schema, value) => {
        const [name, ...args] = value;
        const method = name.substr(DEFINITION_PREFIX.length);
        return schema[method](...args.map(mapArgument));
    }, instance);
};
function transformObject(json, instance = yup) {
    return Object.entries(json).reduce((obj, [key, value]) => ({
        ...obj,
        [key]: isYupSchemaDefinition(value)
            ? transformSchema(value, instance)
            : value,
    }), {});
}
exports.transformObject = transformObject;
function transformAll(json, instance = yup) {
    const wrapped = Array.isArray(json[0]) ? json : [json];
    if (!isYupSchemaDefinition(wrapped)) {
        return instance.mixed();
    }
    return transformSchema(wrapped, instance);
}
exports.transformAll = transformAll;
//# sourceMappingURL=index.js.map